/// <amd-module name="Search/Shared/Base/Sources/SearchOrgButtonEnabledSource" />

import { IVssContributionService } from "VSS/Platform/Contribution";
import { IVssPageContext } from "VSS/Platform/Context";

export class SearchOrgButtonEnabledSource {
    public static DATA_PROVIDER_ID = "ms.vss-search-platform.collection-to-org-search-navigation-enabled-data-provider";
    public isSearchOrgButtonEnabled(pageContext: IVssPageContext): boolean {
        const contributionService: IVssContributionService =
            pageContext.getService<IVssContributionService>("IVssContributionService");
        const response: any = contributionService.getData(SearchOrgButtonEnabledSource.DATA_PROVIDER_ID);
        return response;
    }
}
